function gtg() {
    dataLayer.push(arguments);
};

export const gaEngagement = (action, label) => {
    gtg('event', action, {
        event_category: 'engagement',
        event_label: label,
    });
};

export const gaConversion = (action, sendTo, txnID) => {
    gtg('event', action, {
        send_to: sendTo || process.env.VUE_APP_GOOGLE_ANALYTICS_SEND_TO,
        transaction_id: txnID,
    });
};

export const pauseSubscription = (stepAttempt, pauseReason) => {
    dataLayer.push({
        event: 'pauseSubscription',
        pause: {
            step: 'attempt',
            reason: pauseReason,
            resolution: stepAttempt,
        },
    });
};

const setCustomVariables = (customVariables, scope) => {
    let entries = Object.entries(customVariables);

    // Pushing Custom variables to dataLayer (for GTM)
    entries.map((entry) => {
        dataLayer.push({ [entry[0]]: entry[1] });
    });
};

export const CSPageEvents = (eventName, customVariables, scope = 'visit') => {
    window._uxa = window._uxa || [];
    if (eventName) window._uxa.push(['trackPageEvent', eventName]);
    if (customVariables) {
        setCustomVariables(customVariables, scope);

        // Pushing a specific Custom variable to dataLayer (for GTM)
        dataLayer.push({ 'country': process.env.VUE_APP_COUNTRY_ISO });
    }
};

export const CSPageView = (url) => {
    window._uxa = window._uxa || [];
    window._uxa.push(['trackPageview', url]);
};
